import React from 'react'
import { StepIconProps } from '@mui/material/StepIcon'
import CheckIcon from '@mui/icons-material/Check'
import { Box } from '@mui/material'

const CustomStepIcon = (props: StepIconProps) => {
  const { active, completed } = props

  return (
    <Box
      sx={{
        backgroundColor: active || completed ? '#7766B3' : '#F1F3F4',
        color: '#fff',
        width: 24,
        height: 24,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      {completed ? <CheckIcon sx={{ fontSize: 16 }} /> : null}
    </Box>
  )
}

export default CustomStepIcon
